var J = Object.defineProperty;
var H = (e, o, t) => o in e ? J(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t;
var N = (e, o, t) => H(e, typeof o != "symbol" ? o + "" : o, t);
import { z as n } from "zod";
import { corporateIdSchema as W, employerIdSchema as F, nameSchema as V, accountIdSchema as x, responseDecoder as y, authErr as f, HttpFailure as K, ErrorCodes as Q, definedNotNull as d } from "@df/common";
import { createLocalStorageStore as b, resetStoresAndLogout as P, apiUrl as w, clearStorage as T, loginUrl as a, safeReturnPath as X, currentReturnPath as Y, endSessionReturningHere as v } from "@df/utils";
import { ok as p, err as Z } from "neverthrow";
import * as g from "@azure/msal-browser";
const z = n.object({
  audit: n.boolean(),
  analysis: n.boolean()
}), Oe = (e) => z.parse(e), j = n.object({
  id: F,
  corporateId: W,
  name: n.string(),
  network: n.string().optional()
}), Le = (e) => j.parse(e), R = n.object({
  id: x,
  name: V,
  email: n.string(),
  inactivated: n.boolean()
}), Ue = (e) => R.parse(e), G = n.object({
  account: R,
  defaultEmployer: j
}), je = (e) => G.parse(e), ee = n.object({
  account: R,
  defaultEmployer: j,
  token: n.string(),
  access: z.default({ audit: !0, analysis: !0 })
}), oe = (e) => ee.parse(e), te = n.object({
  homeAccountId: n.string(),
  environment: n.string(),
  tenantId: n.string(),
  username: n.string(),
  localAccountId: n.string(),
  name: n.string().optional(),
  idToken: n.string().optional(),
  nativeAccountId: n.string().optional(),
  authorityType: n.string().optional()
}), ne = (e) => te.parse(e), re = n.object({
  token: n.string(),
  user: G
}), se = (e) => re.parse(e), ie = n.object({
  idToken: n.string(),
  refreshToken: n.string().optional()
}), L = (e) => ie.parse(e), ce = n.discriminatedUnion("ssoProvider", [
  n.object({
    ssoProvider: n.literal("Microsoft"),
    tenantId: n.string().optional(),
    displayName: n.string().nullable().optional(),
    verifiedDomains: n.array(
      n.object({
        capabilities: n.string().optional(),
        isDefault: n.boolean().optional(),
        isInitial: n.boolean().optional(),
        name: n.string().optional(),
        type: n.string().optional()
      })
    ).optional()
  }),
  n.object({
    ssoProvider: n.literal("Google"),
    displayName: n.string()
  }),
  n.object({ ssoProvider: n.literal("BankId"), displayName: n.string() })
]), ae = (e) => ce.parse(e), le = n.custom(
  (e) => typeof e == "string" && e.startsWith("Bearer "),
  { message: "Cannot decode Bearer token: value does not start with 'Bearer '" }
), Re = (e) => le.parse(e), ue = n.object({
  seed: n.string(),
  jwt: n.string()
}), Ce = (e) => ue.parse(e), de = () => {
};
function fe(e) {
  {
    const o = new Error(`rune_outside_svelte
The \`${e}\` rune is only available inside \`.svelte\` and \`.svelte.js/ts\` files
https://svelte.dev/e/rune_outside_svelte`);
    throw o.name = "Svelte error", o;
  }
}
function ge(e, o, t) {
  if (e == null)
    return o(void 0), de;
  const r = pe(
    () => e.subscribe(
      o,
      // @ts-expect-error
      t
    )
  );
  return r.unsubscribe ? () => r.unsubscribe() : r;
}
function h(e) {
  let o;
  return ge(e, (t) => o = t)(), o;
}
let O = !1;
function pe(e) {
  var o = O;
  try {
    return O = !0, e();
  } finally {
    O = o;
  }
}
{
  let e = function(o) {
    if (!(o in globalThis)) {
      let t;
      Object.defineProperty(globalThis, o, {
        configurable: !0,
        // eslint-disable-next-line getter-return
        get: () => {
          if (t !== void 0)
            return t;
          fe(o);
        },
        set: (r) => {
          t = r;
        }
      });
    }
  };
  e("$state"), e("$effect"), e("$derived"), e("$inspect"), e("$props"), e("$bindable");
}
const k = b(
  "employer",
  ae,
  (e) => {
    P("employer", e);
  }
), U = b(
  "refreshToken",
  (e) => n.string().parse(e),
  (e) => {
    P("refreshToken", e);
  }
), S = b(
  "user",
  oe,
  (e) => {
    P("user", e);
  }
), A = b(
  "microsoftAccount",
  ne,
  (e) => {
    P("microsoftAccount", e);
  }
);
function he(e) {
  const o = e.user;
  S.set({
    token: e.token,
    account: o.account,
    defaultEmployer: o.defaultEmployer,
    // TODO: include access from LoginResponse once the server returns it
    access: { audit: !0, analysis: !0 }
  });
}
async function D(e) {
  return fetch(`${w}auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      action: {
        method: `Sso${e.ssoProvider}`,
        idToken: e.idToken
      },
      versions: {}
    })
  }).then(async (o) => {
    if (o.ok) {
      const t = await o.json(), r = y(se)(t);
      if (r.status == "Success")
        return r.data;
    }
    throw o;
  });
}
async function C(e, o) {
  D(e).then(async (t) => {
    he(t), o();
  });
}
let B, E, I;
function $e(e) {
  google ? (B = google.accounts.oauth2.initCodeClient({
    client_id: process.env.GOOGLE_SSO_CLIENT_ID ?? "",
    scope: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid profile",
    callback: async (o) => {
      try {
        const t = await fetch(`${w}auth/authorize_code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ action: { code: o.code }, versions: {} })
        });
        if (t.ok) {
          const r = await t.json(), s = y(L)(r);
          if (console.info("data", s), s.status === "Success") {
            const { refreshToken: c, idToken: q } = s.data;
            if (k.set({
              ssoProvider: "Google",
              displayName: ""
            }), d(c))
              U.set(c);
            else
              throw `Google refresh token missing from response: ${s}`;
            C(
              {
                ssoProvider: "Google",
                idToken: q
              },
              e
            );
          } else
            throw `Could not get google response token: ${s.code} - ${s.message}`;
        }
      } catch (t) {
        console.error("Failed to authenticate with google:", t);
      }
    }
  }), E = google.accounts.oauth2.initCodeClient({
    client_id: process.env.GOOGLE_SSO_CLIENT_ID ?? "",
    scope: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid profile",
    callback: async (o) => {
      try {
        console.info("Google new user callback");
        const t = await fetch(`${w}auth/authorize_code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ action: { code: o.code }, versions: {} })
        });
        if (t.ok) {
          const r = await t.json(), s = y(L)(r);
          if (console.info("data", s), s.status === "Success")
            if (I) {
              const { idToken: c } = s.data;
              I(c);
            } else
              throw "Could not resolve idToken for new user";
          else
            throw `Could not get google response token for new user: ${s.code} - ${s.message}`;
        }
      } catch (t) {
        console.error("Failed to authenticate with google for new user:", t);
      }
    }
  })) : console.error("No google");
}
class ke {
  async startLoginProcess() {
    B.requestCode();
  }
  async getIdTokenWithPopup() {
    const t = await new Promise((r) => {
      I = r, E.requestCode();
    });
    return k.set({
      ssoProvider: "Google",
      displayName: ""
    }), I = void 0, t;
  }
  async fetchAccessToken() {
    throw "`fetchAccessToken` is not implemented for Google SSO";
  }
  async renewToken() {
    console.info("Google renew token");
    try {
      const o = h(U), t = await fetch(`${w}auth/refresh_token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ action: { refreshToken: o }, versions: {} })
      });
      if (t.ok) {
        const s = await t.json(), c = y(L)(s);
        return c.status === "Success" ? p(c.data.idToken) : f("UserTokenRetrieval", c.stringify(), { signInGone: !0 });
      }
      const r = await K.fromResponse(t);
      return f(
        "UserTokenRetrieval",
        `Could not get idToken, ${r.code}: ${r.message}`,
        { signInGone: r.code === Q.AUTH_SIGN_IN_GONE }
      );
    } catch (o) {
      return f("UserTokenRetrieval", `Failed to refresh Google token: ${o}`);
    }
  }
  async fetchOrganizationInfo() {
  }
  logout() {
    const o = h(U);
    d(o) && d(google) ? google.accounts.oauth2.revoke(o, () => {
      T(), location.href = a;
    }) : (T(), location.href = a);
  }
}
const $ = new ke(), M = ["user.read", "profile", "email"], me = [
  "monitor_window_timeout",
  "block_nested_popups",
  "window.open returned null or undefined window object",
  "PopupHandler.monitorPopupForHash - window closed",
  "SilentHandler:monitorIFrameForHash"
], ye = {
  auth: {
    clientId: "a9545a19-6a44-4bd4-a133-6afb930cd157",
    navigateToLoginRequestUrl: !0
  },
  cache: {
    cacheLocation: "localStorage"
  },
  system: {
    loggerOptions: {
      logLevel: g.LogLevel.Verbose,
      loggerCallback: (e, o) => {
        if (!me.some((t) => o.includes(t)))
          switch (e) {
            case g.LogLevel.Error:
              console.error(o);
              return;
            case g.LogLevel.Info:
              console.info(o);
              return;
            case g.LogLevel.Verbose:
              console.debug(o);
              return;
            case g.LogLevel.Warning:
              console.warn(o);
              return;
          }
      },
      piiLoggingEnabled: !0
    }
  }
}, i = new g.PublicClientApplication(ye);
i.initialize().then(() => {
  i.handleRedirectPromise().then(async (e) => {
    console.info(`handleRedirectResult: ${JSON.stringify(e)}`);
    const o = h(A);
    let t = null;
    if (e === null) {
      if (d(o) && (t = i.getAccount({ homeAccountId: o.homeAccountId })), !d(t)) {
        const s = i.getAllAccounts();
        if (console.log("========", s), s.length < 1)
          return;
        s.length === 1 ? t = s[0] : (console.log(`MULTIPLE ACCOUNTS: ${JSON.stringify(s)}`), t = await i.acquireTokenPopup({
          scopes: M,
          prompt: "select_account",
          redirectUri: a
        }).then((c) => (console.log("multipleAccountsResolvedWithPopupSelectAccount"), c.account)).catch(() => (console.log("multipleAccountsResolvedWithSelectingFirstAccount"), s[0])));
      }
    } else
      t = e.account;
    if (d(t))
      A.set(t), i.setActiveAccount(t);
    else {
      console.error("Could not set MSAL account because it was null"), console.log(`res: ${JSON.stringify(e)}`), console.log(`microsoftAccount: ${JSON.stringify(o)}`);
      return;
    }
    const r = await m.fetchOrganizationInfo();
    if (k.set({
      ssoProvider: "Microsoft",
      tenantId: r.value[0].id,
      displayName: r.value[0].displayName,
      verifiedDomains: r.value[0].verifiedDomains
    }), e !== null) {
      const s = X(e.state);
      C({ ssoProvider: "Microsoft", idToken: e.idToken }, () => {
        location.href = s ?? "/";
      });
    }
  }).catch((e) => {
    console.error(`Error handling redirect promise in MSAL: ${JSON.stringify(e)}`);
  });
});
class we {
  constructor() {
    N(this, "defaultAzureScopes");
    N(this, "orgUrl", "https://graph.microsoft.com/v1.0/organization");
    this.defaultAzureScopes = M;
  }
  async startLoginProcess() {
    i.loginRedirect({
      scopes: this.defaultAzureScopes,
      redirectUri: a,
      state: Y()
    });
  }
  async getIdTokenWithPopup() {
    const o = await i.loginPopup({ scopes: this.defaultAzureScopes });
    A.set(o.account), i.setActiveAccount(o.account);
    const t = await m.fetchOrganizationInfo();
    return k.set({
      ssoProvider: "Microsoft",
      tenantId: t.value[0].id,
      displayName: t.value[0].displayName,
      verifiedDomains: t.value[0].verifiedDomains
    }), o.idToken;
  }
  async fetchAccessToken() {
    return i.acquireTokenSilent({
      scopes: this.defaultAzureScopes,
      redirectUri: a
    }).then((o) => o.accessToken);
  }
  async renewToken() {
    console.log("RENEW TOKEN");
    const o = h(A);
    return console.log("Renew token for account", o), o ? (i.setActiveAccount(o), i.acquireTokenSilent({
      scopes: this.defaultAzureScopes,
      forceRefresh: !0,
      account: o ?? void 0,
      redirectUri: a
    }).then((t) => (console.info("Acquired token silently", t.idToken), i.setActiveAccount(t.account), p(t.idToken))).catch(async (t) => (console.warn(`Acquiring token silently failed: ${JSON.stringify(t)}`), i.acquireTokenPopup({
      scopes: this.defaultAzureScopes,
      redirectUri: a,
      loginHint: o == null ? void 0 : o.username
    }).then((r) => (console.info("Acquired token via popup"), i.setActiveAccount(r.account), p(r.idToken))).catch((r) => (console.warn(`Acquiring token with popup failed: ${JSON.stringify(r)}`), i.loginPopup({
      scopes: this.defaultAzureScopes,
      redirectUri: a
    }).then((s) => (console.info("Acquired token via login popup"), i.setActiveAccount(s.account), p(s.idToken))).catch((s) => (v(), f(
      "UserTokenRetrieval",
      `Cannot renew Microsoft token even after a lot of tries, logging user out: ${JSON.stringify(
        s
      )}`
    )))))))) : (v(), f(
      "UserTokenRetrieval",
      "Missing Microsoft account in local storage, logging user out"
    ));
  }
  async fetchOrganizationInfo() {
    const o = await this.fetchAccessToken();
    return await (await fetch(this.orgUrl, {
      headers: { Authorization: "Bearer " + o }
    })).json();
  }
  getActiveAccountReference() {
    var t;
    const o = i.getActiveAccount();
    return {
      ref: "SsoMicrosoft",
      tid: o == null ? void 0 : o.tenantId,
      oid: (t = o == null ? void 0 : o.idTokenClaims) == null ? void 0 : t.oid
    };
  }
  async logout() {
    T(), await i.logoutRedirect({
      postLogoutRedirectUri: a
    });
  }
}
const m = new we();
let u;
function _e(e) {
  return u = e, () => {
    u === e && (u = void 0);
  };
}
class Te {
  async startLoginProcess(o) {
    if (!u)
      return;
    const t = await u();
    t.isOk() && (await C({ ssoProvider: "BankId", idToken: t.value }, o), k.set({ ssoProvider: "BankId", displayName: "" }));
  }
  async verifyIdentity() {
    return u ? u() : f("UserTokenRetrieval", "No BankID UI mounted");
  }
  async fetchAccessToken() {
    throw "`fetchAccessToken` is not implemented for BankID SSO";
  }
  async renewToken() {
    return u ? u() : (v(), f("UserTokenRetrieval", "No BankID renew UI mounted"));
  }
  async fetchOrganizationInfo() {
  }
  logout() {
    T(), location.href = a;
  }
}
const _ = new Te();
async function ze(e, o, t) {
  switch (e.type) {
    case "Microsoft":
      return await m.startLoginProcess();
    case "Google":
      return $.startLoginProcess();
    case "BankId":
      return _.startLoginProcess(o);
    default:
      t();
  }
}
async function Ge(e) {
  switch (e.type) {
    case "Microsoft":
      return await m.logout();
    case "Google":
      return $.logout();
    case "BankId":
      return _.logout();
  }
}
async function ve(e) {
  switch (e.type) {
    case "Microsoft":
      return (await m.renewToken()).map((o) => ({
        ssoProvider: "Microsoft",
        idToken: o
      }));
    case "Google":
      return (await $.renewToken()).map((o) => ({
        ssoProvider: "Google",
        idToken: o
      }));
    case "BankId":
      return (await _.renewToken()).map((o) => ({
        ssoProvider: "BankId",
        idToken: o
      }));
  }
}
function De() {
  const e = h(S);
  if (!(!d(e) || !e.token))
    return `Bearer ${e.token}`;
}
let l;
function Be(e) {
  if ((l == null ? void 0 : l.provider) === e)
    return l.token;
  const o = Se(e).finally(() => {
    (l == null ? void 0 : l.token) === o && (l = void 0);
  });
  return l = { provider: e, token: o }, o;
}
async function Se(e) {
  const o = await ve({ type: e });
  return o.isErr() ? (o.error.signInGone === !0 && v(), Z(o.error)) : await D(o.value).then((t) => {
    if (t.user.account.inactivated)
      throw S.update((r) => (d(r) && (r.account.inactivated = !0), r)), `User is inactivated - ${(/* @__PURE__ */ new Date()).getTime()}`;
    return t;
  }).then(({ token: t }) => (S.update((r) => (d(r) && (r.token = t), r)), p(`Bearer ${t}`))).catch((t) => (console.error(t), f("UserTokenRetrieval", "Could not login for renewal of Authorization token")));
}
export {
  _ as BankIdSsoImpl,
  $ as GoogleSsoImpl,
  m as MicrosoftSsoImpl,
  Ue as accountInfoDecoder,
  R as accountInfoSchema,
  Oe as appAccessDecoder,
  z as appAccessSchema,
  Re as bearerTokenDecoder,
  le as bearerTokenSchema,
  Le as employerInfoDecoder,
  j as employerInfoSchema,
  k as employerStorage,
  U as googleRefreshToken,
  L as googleTokenResponseDecoder,
  ie as googleTokenResponseSchema,
  $e as initialize,
  D as loginRequest,
  se as loginResponseDecoder,
  re as loginResponseSchema,
  ne as microsoftAccountDecoder,
  te as microsoftAccountSchema,
  A as microsoftAccountStorage,
  Ce as natsUserCredentialsDecoder,
  ue as natsUserCredentialsSchema,
  ae as organizationInfoDecoder,
  ce as organizationInfoSchema,
  _e as registerBankIdAuthPrompt,
  Be as renewAuthorizationToken,
  he as setUserStorage,
  C as ssoLoginCallback,
  ve as ssoRenewToken,
  ze as startSsoLoginProcess,
  Ge as startSsoLogoutProcess,
  De as storedUserToken,
  je as userInfoDecoder,
  G as userInfoSchema,
  S as userStorage,
  oe as userStorageDecoder,
  ee as userStorageSchema
};
//# sourceMappingURL=df-auth.js.map
